import { DotsLoader, Sidecar } from '@eppendorf/vnls-react-components';
import { type ReactElement, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import { LoadingErrorHint } from '$components/loading-error-hint/loading-error-hint';
import { SidecarRouterOutlet } from '$components/sidecar-router/sidecar-router-outlet';
import { useGetRunRecordReport } from '$features/report-hub/run-record/run-record-detail.api';
import { RunRecordSidecarHeader } from '$features/report-hub/run-record/run-record-sidecar-header';

import '../stability-report/stability-report-sidecar.scss';

export function RunRecordSidecar(): ReactElement {
  const [searchParams, setSearchParams] = useSearchParams();
  const [isSidecarOpen, setIsSidecarOpen] = useState(true);

  const reportId = searchParams.get('id');
  const { isError, isLoading, data: report } = useGetRunRecordReport(reportId);

  const handleSidecarOpenChange = () => {
    setIsSidecarOpen(false);
    setSearchParams(
      (prev) => {
        prev.delete('sidecarRoute');
        prev.delete('id');
        return prev;
      },
      { replace: true },
    );
  };

  return (
    <Sidecar isOpen={isSidecarOpen} onOpenChange={handleSidecarOpenChange}>
      {isLoading && <DotsLoader className="m-top-xl" />}

      {isError && <LoadingErrorHint className="m-top-xl" />}

      {report && (
        <div className="flex flex__dir--column flex__ai--stretch h-full">
          <RunRecordSidecarHeader report={report} />
          <div className="sidecar__details box box-remove-padding">
            <div className="sidecar__outlet-wrapper">
              <SidecarRouterOutlet />
            </div>
          </div>
        </div>
      )}
    </Sidecar>
  );
}
